import React from "react";
import { ReactNode } from "react";
import ObservableState from "../utils/ObservableState";
import * as ui from "../native";
import ObservableComponent from "./ObservableComponent";
import BaseUIProps, { copyBaseUIProps } from "../native/ui/BaseUIProps";
import D3EFeature from "../models/D3EFeature";
import ListWrapper from "../utils/ListWrapper";
import ScrollView2 from "./ScrollView2";
import AppFeatureCardView from "./AppFeatureCardView";

type _ProjectFeatureListViewOnReviewFeature = (feature: D3EFeature) => void;

export interface ProjectFeatureListViewProps extends BaseUIProps {
  key?: string;
  features: Array<D3EFeature>;
  isMobileSrc: boolean;
  _featuresHash?: number;
  onReviewFeature?: _ProjectFeatureListViewOnReviewFeature;
}

class _ProjectFeatureListViewState extends ObservableComponent<ProjectFeatureListViewProps> {
  static defaultProps = {
    isMobileSrc: false,
    features: [],
    onReviewFeature: null,
  };
  wrapRefScrollController: ui.ScrollController = new ui.ScrollController();
  public constructor(props: ProjectFeatureListViewProps) {
    super(props);

    this.initState();
  }
  public get features(): Array<D3EFeature> {
    return this.props.features;
  }
  public get isMobileSrc(): boolean {
    return this.props.isMobileSrc;
  }
  public initState() {
    super.initState();

    this.initListeners();

    this.enableBuild = true;
  }
  public initListeners(): void {
    this.subscribeToList(this.features, "features");

    this.updateSyncCollProperty("features", this.props.features);

    this.on(["features", "isMobileSrc"], this.rebuild);
  }
  public componentDidUpdate(prevProps: ProjectFeatureListViewProps): void {
    super.componentDidUpdate(prevProps);

    if (prevProps.features !== this.props.features) {
      this.updateObservableColl(
        "features",
        prevProps.features,
        this.props.features
      );

      this.fire("features", this);
    }

    if (prevProps.isMobileSrc !== this.props.isMobileSrc) {
      this.fire("isMobileSrc", this);
    }
  }
  public render(): ReactNode {
    return ScrollView2({
      child: ui.Wrap({
        spacing: 10,
        runSpacing: 10,
        children: [
          this.features.expand((featureItem) => [
            AppFeatureCardView({
              obj: featureItem,
              isMobileSrc: this.isMobileSrc,
              onReviewFeature: (feature) => {
                this.onFeatureSelected(feature, featureItem);
              },
              className: "vc",
              key: featureItem?.ident,
            }),
          ]),
        ],
        className: ui.join(
          this.props.className,
          "ProjectFeatureListView xa6 vc"
        ),
        ...copyBaseUIProps(this.props),
      }),
      scrollDirection: ui.Axis.vertical,
      className: "ProjectFeatureListView xa6 vc",
      controller: this.wrapRefScrollController,
    });
  }
  public onFeatureSelected = (
    feature: D3EFeature,
    featureItem: D3EFeature
  ): void => {
    this.onReviewFeature(feature);
  };
  public get onReviewFeature(): _ProjectFeatureListViewOnReviewFeature {
    return this.props.onReviewFeature;
  }
}
export default function ProjectFeatureListView(
  props: ProjectFeatureListViewProps
) {
  return React.createElement(
    _ProjectFeatureListViewState,
    { ..._ProjectFeatureListViewState.defaultProps, ...props },
    ListWrapper.fromInput<D3EFeature>(props.features, "features")
  );
}
